module.exports = __webpack_public_path__ + "media/3_5-1.f37c72f4.mp3";